"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RundownDetail = exports.RundownListing = exports.RundownRow = void 0;
const zod_1 = require("zod");
const blobData_1 = require("./blobData");
const rundownSchema_1 = require("./rundownSchema");
const common_1 = require("./common");
exports.RundownRow = zod_1.z.object({
    id: common_1.IntegerId,
    rundownId: common_1.IntegerId,
    blobData: blobData_1.BlobData,
    sequence: zod_1.z.number().int(),
    identityScriptId: zod_1.z.string().nullable(),
    linkedScriptId: zod_1.z.string().nullable(),
    blockId: zod_1.z.string().nullable(),
    rowTypeId: zod_1.z.string(),
});
exports.RundownListing = zod_1.z.object({
    id: common_1.IntegerId,
    name: zod_1.z.string(),
    folderId: common_1.Uuid,
    createdAt: common_1.SerializableDate,
    contentsModifiedAt: common_1.SerializableDate,
    contentsModifiedBy: common_1.Uuid,
});
exports.RundownDetail = zod_1.z.intersection(exports.RundownListing, zod_1.z.object({
    rows: zod_1.z.array(exports.RundownRow),
    blobData: blobData_1.BlobData,
    schema: zod_1.z.object({
        id: zod_1.z.number().int(),
        name: zod_1.z.string(),
        description: zod_1.z.string(),
        schema: rundownSchema_1.RundownSchema,
    }),
}));
